import http from '@/http';

export default class AuthService {

	confirmarEmail(token) {
		return http.get(`auth/confirmacao/validar/${token}`).then(res => res.data);
    }

	enviarEmailConfirmacao(email) {
		return http.get(`auth/confirmacao/enviarEmailConfirmacao/${email}`).then(res => res.data);
    }

}
